import { PROJECT_VIEW_KEYS } from 'modules/work-implementation/constants';

export const PROJECT_VIEW_OPTIONS = [
  { label: 'Not Started', value: PROJECT_VIEW_KEYS.NOT_STARTED },
  { label: 'Assigned', value: PROJECT_VIEW_KEYS.ASSIGNED },
  { label: 'In Progress', value: PROJECT_VIEW_KEYS.IN_PROGRESS },
  { label: 'Cancelled', value: PROJECT_VIEW_KEYS.CANCELLED },
  { label: 'On Hold', value: PROJECT_VIEW_KEYS.ON_HOLD },
  { label: 'Completed', value: PROJECT_VIEW_KEYS.COMPLETED },
];

export const EMPTY_PROJECTS_BY_STATUS = {
  [PROJECT_VIEW_KEYS.NOT_STARTED]: [],
  [PROJECT_VIEW_KEYS.ASSIGNED]: [],
  [PROJECT_VIEW_KEYS.IN_PROGRESS]: [],
  [PROJECT_VIEW_KEYS.CANCELLED]: [],
  [PROJECT_VIEW_KEYS.ON_HOLD]: [],
  [PROJECT_VIEW_KEYS.COMPLETED]: [],
};

export const EMPTY_TABLE_MESSAGES = {
  [PROJECT_VIEW_KEYS.NOT_STARTED]: 'No new jobs found',
  [PROJECT_VIEW_KEYS.ASSIGNED]: 'No jobs currently assigned',
  [PROJECT_VIEW_KEYS.IN_PROGRESS]: 'No jobs currently in progress',
  [PROJECT_VIEW_KEYS.CANCELLED]: 'No cancelled jobs',
  [PROJECT_VIEW_KEYS.ON_HOLD]: 'No jobs currently on hold',
  [PROJECT_VIEW_KEYS.COMPLETED]: 'No completed jobs',
};
